import { SearchAddressResponseItem } from "../../../../../common/utils/search-address/search-address.response";
import DriverAddressFormAddress from "./types/driver-address-form-address";
import DriverAddressFormData from "./types/driver-address-form-data";
import DriverAddressFormOption from "./types/driver-address-form-option";
import DriverAddressFormSearchSelectOption from "./types/driver-address-form-search-select-option";

const createSearchAddressOption = (
  searchAddressResponseItem: SearchAddressResponseItem
): DriverAddressFormOption => {
  return {
    displayName: searchAddressResponseItem.display_name,
    apartmentNumber: "",
    country: searchAddressResponseItem.address.country,
    countryCode: searchAddressResponseItem.address.country_code,
    houseNumber: searchAddressResponseItem.address.house_number ?? null,
    latitude: Number(searchAddressResponseItem.lat),
    longitude: Number(searchAddressResponseItem.lon),
    street: searchAddressResponseItem.address.road ?? null,
    town:
      searchAddressResponseItem.address.city ??
      searchAddressResponseItem.address.town ??
      searchAddressResponseItem.address.village ??
      null,
    zipCode: searchAddressResponseItem.address.postcode ?? null,
  };
};

const createSearchAddressSelectOption = (
  searchAddressResponseItem: SearchAddressResponseItem
): DriverAddressFormSearchSelectOption => {
  const address = createSearchAddressOption(searchAddressResponseItem);

  return {
    label: searchAddressResponseItem.display_name,
    value: address,
  };
};

const createAddressSelectOptions = (
  searchAddressResponseItems: SearchAddressResponseItem[]
): DriverAddressFormSearchSelectOption[] => {
  return searchAddressResponseItems.map(createSearchAddressSelectOption);
};

const createAddress = (
  formData: DriverAddressFormData
): DriverAddressFormAddress => {
  return {
    apartmentNumber: formData.apartmentNumber,
    country: formData.country,
    description: formData.description,
    houseNumber: formData.houseNumber,
    latitude: formData.foundAddress?.value.latitude!,
    longitude: formData.foundAddress?.value.longitude!,
    street: formData.street,
    town: formData.town,
    type: formData.type?.value!,
    zipCode: formData.zipCode,
  };
};

const driverAddressFormFactory = {
  createSearchAddressOption,
  createAddressSelectOptions,
  createAddress,
};

export default driverAddressFormFactory;
